// extracted by mini-css-extract-plugin
export default {"melodyVideo":"EL-z","isFullWidth":"FL-z","landingPageVideo":"GL-z","play":"HL-z","iframeVideo":"IL-z","playHidden":"JL-z","fullwidth":"KL-z"};